var _circle, _circle2, _g, _text, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnsSeal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 47,
    fill: "#1c1712",
    stroke: "#9c7539",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 39.5,
    fill: "none",
    stroke: "#f6efe0",
    strokeWidth: 0.75,
    opacity: 0.45
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#b9924f",
    strokeWidth: 1,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 6 L50 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 88 L50 94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 50 L12 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 50 L94 50"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 60,
    textAnchor: "middle",
    fontFamily: "'Cormorant Garamond', Georgia, 'Times New Roman', serif",
    fontSize: 30,
    letterSpacing: 2,
    fill: "#f6efe0"
  }, "SNS")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 66,
    width: 7,
    height: 7,
    fill: "#b9924f",
    transform: "rotate(45 50 69.5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsSeal);
export default __webpack_public_path__ + "static/media/sns-seal.8724c2036423a26ef8bd7d2fcc4f0608.svg";
export { ForwardRef as ReactComponent };